import productService from '../api';
import { 
  SET_PRODUCT, 
  SET_PLUGIN_INFO,
  SET_BRIEFS,
  SET_BRIEFS_LOADING,
  SET_ADOBE_RATING,
  SET_RATING_LOADING,
  SET_RATING_PAGINATION,
  SET_RATING_PREVIEW,
  SET_RATING_HISTORY,
} from './product.constants';

export const getPluginTC = (type) => {
  return async (dispatch) => {
    try {
      const data = await productService.getPlugin(type);

      if(data?.status === 200) {
        const blob = new Blob([data.data], {
          type: 'application/zip',
        });

        return blob;
      }

      throw new Error("The server did not return a result");
    } catch (error) {
      console.log(error);
      alert('Error download file.', error)
    }
  }
}

export const getPluginInfoTC = () => {
  return async (dispatch) => {
    try {
      const resp = await productService.getPluginInfo();
      
      dispatch(setPluginInfoAC(resp?.data));
    } catch (error) {
      console.log(error);
    }
  }
}

export const getBriefsTC = () => {
  return async (dispatch) => {
    try {
      const resp = await productService.getBriefs();

      dispatch(setBriefsAC(resp?.data));
    } catch (error) {
      console.log(error);
    }
  }
}

export const getAdobeRatingTC = (params) => {
  return async (dispatch) => {
    try {
      const data = await productService.getAdobeRating(params);

      if (!data) {
        return;
      }

      let { rows, count } = data.data;

      if (!count) {
        count = 1;
      }

      dispatch(setAdobeRatingAC(rows));
      dispatch(setRatingPaginationAC(count))
      // Признак урезанной выдачи решает бэкенд — клиент не дублирует проверку доступа adobe.
      dispatch(setRatingPreviewAC(data.data?.isPreview))
    } catch (error) {
      console.log(error);
    }
  }
}

export const getAdobeRatingHistoryTC = (id) => {
  return async (dispatch) => {
    try {
      const data = await productService.getAdobeRatingHistory(id);
      // Бэкенд отдаёт от новых к старым, графику нужен обратный порядок.
      const history = data?.data?.history || [];

      dispatch(setRatingHistoryAC([...history].reverse()));
    } catch (error) {
      // 403 — нет доступа adobe, это штатный ответ для витрины, а не сбой.
      console.log(error);
      dispatch(setRatingHistoryAC([]));
    }
  }
}

//ACTIONS
export const setProductAC = (payload) => {
  return {
    type: SET_PRODUCT,
    payload,
  };
};

export const setPluginInfoAC = (payload) => {
  return {
    type: SET_PLUGIN_INFO,
    payload,
  };
};

export const setBriefsAC = (payload) => {
  return {
    type: SET_BRIEFS,
    payload,
  };
};

export const setBriefsLoadingAC = (payload) => {
  return {
    type: SET_BRIEFS_LOADING,
    payload,
  };
}

export const setAdobeRatingAC = (payload) => {
  return {
    type: SET_ADOBE_RATING,
    payload,
  }
}

export const setRatingLoadingAC = (payload) => {
  return {
    type: SET_RATING_LOADING,
    payload,
  };
}

export const setRatingPaginationAC = (payload) => {
  return {
    type: SET_RATING_PAGINATION,
    payload,
  }
}

export const setRatingPreviewAC = (payload) => {
  return {
    type: SET_RATING_PREVIEW,
    payload,
  }
}

export const setRatingHistoryAC = (payload) => {
  return {
    type: SET_RATING_HISTORY,
    payload,
  }
}
